import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.98 8.544A14.927 14.927 0 0 0 17 16c0 8.286 6.715 15 15 15 2.654 0 5.206-.69 7.456-1.98.81-.466 1.76.336 1.435 1.213A18.003 18.003 0 0 1 24 42c-9.942 0-18-8.057-18-18 0-7.6 4.753-14.303 11.767-16.892.877-.323 1.679.626 1.214 1.436Z",
    fill: "currentColor"
  }));
};

var SvgMoon = styled(SvgComponent).withConfig({
  displayName: "Moon__SvgMoon",
  componentId: "sc-8uk7tt-0"
})(["", " ", ""], size, color);
export default SvgMoon;